import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_OrderPlan_Details/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_OrderPlan_Details/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_OrderPlan_Details/SaveToPlanApprovalModel',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Tx_OrderPlan_Details/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_OrderPlan_Details/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/Tx_OrderPlan_Details/Get',
    method: 'post',
    data: { paramStr: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_OrderPlan_Details/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

// 行关闭
export function Close(data) {
  return request({
    url: '/Tx_OrderPlan_Details/Close',
    method: 'post',
    data: { paramStr: data }
  });
}

// 行开启
export function Open(data) {
  return request({
    url: 'Tx_OrderPlan_Details/Open',
    method: 'post',
    data: { paramStr: data }
  });
}

// 拆分
export function Split(data) {
  return request({
    url: '/Tx_OrderPlan_Details/Split',
    method: 'post',
    data: { paramStr: data }
  });
}

// 合并
export function Concat(data) {
  return request({
    url: '/Tx_OrderPlan_Details/Concat',
    method: 'post',
    data: { paramStr: data }
  });
}

// 转发
export function SaveTransfer(data) {
  return request({
    url: '/Tx_OrderPlan_Details/SaveTransfer',
    method: 'post',
    data: { paramStr: data }
  });
}

// 获取明细
export function GetDetail(data) {
  return request({
    url: '/Tx_OrderPlan_Details/GetDetail',
    method: 'post',
    data: { paramStr: data }
  });
}
